/*
 * @Author: libo 
 * @Date: 2020-11-13 16:54:37 
 * @Last Modified by: libo
 * @Last Modified time: 2020-11-20 11:24:06
 */

<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <meter-openAccount-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-openAccount-form>
  </j-modal>
</template>

<script>

  import MeterOpenAccountForm from './MeterOpenAccountForm'
  export default {
    name: 'MeterOpenAccountModal',
    components: {
      MeterOpenAccountForm
    },
    data () {
      return {
        title:'',
        width:1024,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
          console.log();
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>